import styled from 'styled-components';

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 24px;  
    padding:25px 0;
`;

export const Title = styled.h1`
    font-size: 24px;
    line-height: 1.5; 
    font-weight: 500;
    color: #1C1C1C;
    text-align: center;
`;

export const SubTitle = styled.p`
  font-size: 14px;
  line-height: 1.7; 
  font-weight: 400;
  color: #3F3F46; 
  padding:10px;
  text-align:center;
`;

export const Image = styled.img`

    max-width: 500px;
    width: 100%;
    height:auto;
    object: contain;
`;

export const AppButtonContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    gap: 12px;
`;

export const AppButton = styled.a`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 60px;
    width:100%;
    padding: 8px 10px;
    background-color: #fff;
    border: 1px solid #E4E4E7;
    border-radius: 10px;
    overflow: hidden;
`;

export const AppButtonImage = styled.img`
    width: auto;
    height: 100%;
`;
